import React from 'react';
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function PositionedSnackbar({ ...other }) {
  const [state, setState] = React.useState({
    vertical: 'top',
    horizontal: 'center',
  });

  const { vertical, horizontal } = state;

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={other.open}
        key={vertical + horizontal}
      >
        <Alert variant={other.filled} onClose={other.handleClose} severity={other.severity}>
          {other.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
